<script setup lang="ts">
const open = ref(false)
const route = useRoute()

watch(
  () => route.name,
  () => {
    open.value = false
  },
)
</script>

<template>
  <header class="flex items-center justify-between px-4 py-3 lg:hidden">
    <NuxtLink
      :to="{ name: 'dashboard' }"
      class="flex items-center gap-1 text-sm font-medium text-zinc-700"
    >
      <SvgoPikaChevronLeft class="size-5" />
      {{ $t("navigation.settings.back_to_app") }}
    </NuxtLink>
    <button
      type="button"
      class="rounded-lg p-2 text-zinc-800 hover:bg-zinc-950/5"
      :aria-label="$t('navigation.settings.index')"
      @click="open = true"
    >
      <svg class="size-5" viewBox="0 0 20 20" aria-hidden="true">
        <path
          fill="currentColor"
          d="M2 6.75c0-.414.336-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Zm0 6.5c0-.414.336-.75.75-.75h14.5a.75.75 0 0 1 0 1.5H2.75a.75.75 0 0 1-.75-.75Z"
        />
      </svg>
    </button>
  </header>
  <DialogWrapper v-model:open="open">
    <dialog
      :open
      class="@container/navigation fixed inset-2 m-0 h-full max-h-[98svh] w-4/5 rounded-lg bg-white p-0 ring-3 ring-zinc-200"
    >
      <div class="flex h-full flex-col">
        <div
          class="flex items-center justify-between border-b border-zinc-950/5 p-4"
        >
          <span class="font-semibold">{{
            $t("navigation.settings.index")
          }}</span>
          <button
            type="button"
            :aria-label="$t('navigation.settings.close_navigation')"
            @click="open = false"
          >
            <SvgoPikaClose class="size-6 text-zinc-500" />
          </button>
        </div>
        <div class="overflow-y-auto p-3">
          <SettingsNavigationItems />
        </div>
      </div>
    </dialog>
  </DialogWrapper>
</template>
